import "./rangeSlider.scss";
import { Slider } from "@mui/material";
import { Input } from "@mui/material";

const RangeSlider = ({
  initialValue = 22,
  min = 5,
  max = 231,
  step = 1,
  unit = "cm",
  label,
  minValue,
  maxValue,
  onChange,
}) => {
  const allowsNegativeNumbers = min < 0;

  const handleChange = (event, newValue, finishedEdit, step) => {
    if (isWholeNumber(step) && newValue.toString().includes(".")) {
      return "";
    }
    if (isNaN(newValue) && !isDenotion(newValue)) {
      return ""
    } else if (finishedEdit) {
      if (newValue == "" && !allowsNegativeNumbers) {
        newValue = min;
      } else if (newValue == "" && allowsNegativeNumbers) {
        newValue = 0;
      }
      if (newValue > max) {
        newValue = max;
      } else if (newValue < min) {
        newValue = min;
      }
      removeFocusFromWrapper(event);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  function valueLabelFormat(value) {
    return `${value}${unit}`;
  }

  function isDenotion(newValue) {
    return (allowsNegativeNumbers && (newValue == '-' || newValue == '+'));
  }

  function removeFocusFromWrapper(event) {
    event.target.parentNode.parentNode.style.borderColor = "#DDDDDD";
  }

  function isWholeNumber(step){
    return step % 1 == 0;
  }

  function getInputLabel(initialValue, unit, step) {
    return (
      <>
        <div className="fillableText">
          <Input
            sx={{
              "& .MuiInputBase-input": {
                padding: "0px",
                width: "5ch",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                fontFamily: "Gotham HTF",
                color: "#181818",
              },
            }}
            value={initialValue}
            disableUnderline={true}
            onChange={(e) => handleChange(e, e.target.value, null, step)}
            onBlur={(e) => handleChange(e, e.target.value, true, step)}
            onFocus={(e) => e.target.parentNode.parentNode.style.borderColor = "#000"}
          />
          <span className="pl-1">{unit}</span>
        </div>
      </>
    )
  }

  return (
    <div className="range">
      <div className="rangeTxt">
        <span>{label}</span>
        {getInputLabel(initialValue, unit, step)}
      </div>
      <Slider
        value={isNaN(Number.parseInt(initialValue)) ? null : Number.parseInt(initialValue)}
        min={min}
        step={step}
        max={max}
        getAriaValueText={valueLabelFormat}
        valueLabelFormat={valueLabelFormat}
        onChange={handleChange}
        valueLabelDisplay="auto"
        aria-labelledby="non-linear-slider"
      />
      <div className="minMax">
        <span>{minValue}</span>
        <span>{maxValue}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
